import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { f as focusOutline } from '../../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { h as hoverMixin, C as CheckboxIcon } from '../../Checkbox/CheckboxIcon-SX1KiDyS.js';

const Checkbox = /*#__PURE__*/styled(CheckboxIcon).withConfig({
  componentId: "sc-storm-ui-40025937__sc-1a042f9-0"
})([""]);
const noWrapMixin = noWrap => noWrap && css(["white-space:nowrap;padding-inline-end:", ";"], ({
  theme
}) => theme.controls.paddingInline.base.default);
const RenderWrapper = /*#__PURE__*/styled('span').withConfig({
  componentId: "sc-storm-ui-40025937__sc-1a042f9-1"
})(["display:flex;flex-direction:row;align-items:center;gap:", ";border-radius:", ";", " :not(:last-of-type){margin-block-end:", "}"], ({
  theme
}) => theme.button.padding.gap.small, ({
  theme
}) => theme.border.radius.medium, ({
  noWrap
}) => noWrapMixin(noWrap), ({
  theme
}) => theme.spacing.xxxxsmall.default);
const SelectButton = /*#__PURE__*/styled('button').withConfig({
  componentId: "sc-storm-ui-40025937__sc-1a042f9-2"
})(["position:relative;cursor:pointer;display:flex;align-items:center;flex:1;border:1px solid ", ";cursor:pointer;border-radius:", ";gap:", ";font:", ";padding-block:", ";padding-inline:", ";", " color:", ";background-color:", ";:hover{background-color:", ";}:focus-visible{background-color:", ";}:active{background-color:", ";}", " :disabled{cursor:not-allowed;color:", ";background-color:", ";}:focus-visible{transform:rotate(0);outline:", ";outline-offset:0;}"], ({
  theme
}) => theme.color.transparent, ({
  theme
}) => theme.border.radius.medium, ({
  theme
}) => theme.selectableWidget.controlLabelGap.default, ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.controls.paddingBlock.base.default, ({
  theme
}) => theme.controls.paddingInline.large.default, isMobile(css(["font:", ";padding-block:", ";padding-inline:", ";gap:", ";"], ({
  theme
}) => theme.font.text.base.mobile, ({
  theme
}) => theme.controls.paddingBlock.base.mobile, ({
  theme
}) => theme.controls.paddingInline.xxlarge.mobile, ({
  theme
}) => theme.selectableWidget.controlLabelGap.mobile)), ({
  theme
}) => theme.text.color.default, ({
  theme
}) => theme.button.backgroundColor.transparent.default, ({
  theme
}) => theme.button.backgroundColor.transparent.hover, ({
  theme
}) => theme.button.backgroundColor.transparent.hover, ({
  theme
}) => theme.button.backgroundColor.transparent.active, ({
  selected,
  $multiple,
  disabled
}) => selected && css(["font-weight:", ";", ""], ({
  theme
}) => theme.font.weight.bold, $multiple ? !disabled && css([":hover{", "{", "}}"], Checkbox, hoverMixin) : css(["color:", ";background-color:", ";:hover{background-color:", ";}:focus-visible{background-color:", ";}:active{background-color:", ";}&&::after{content:'';position:absolute;inset-inline-start:", ";inset-block-start:", ";inset-block-end:", ";width:", ";border-radius:", ";background-color:", ";}"], ({
  theme
}) => theme.text.color.default, ({
  theme
}) => theme.surface.container.selected, ({
  theme
}) => theme.surface.container.selected, ({
  theme
}) => theme.surface.container.selected, ({
  theme
}) => theme.surface.container.active, ({
  theme
}) => theme.selectListItem.selectedHighlight.insetInlineStart, ({
  theme
}) => theme.selectListItem.selectedHighlight.insetBlockStart, ({
  theme
}) => theme.selectListItem.selectedHighlight.insetBlockEnd, ({
  theme
}) => theme.selectListItem.selectedHighlight.width, ({
  theme
}) => theme.selectListItem.selectedHighlight.borderRadius, ({
  theme
}) => theme.selectListItem.selectedHighlight.backgroundColor)), ({
  theme
}) => theme.text.color.unavailable, ({
  theme
}) => theme.surface.container.unavailable, ({
  theme
}) => theme.border.focus.default);
const SelectButtonContent = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-1a042f9-3"
})(["text-align:start;display:list-item;list-style-type:none;flex:1;"]);
const MobileFullScreenRadio = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-1a042f9-4"
})(["@media (prefers-reduced-motion:no-preference){transition:color 100ms ease,background-color 100ms ease,border-color 100ms ease,box-shadow 100ms ease;}position:relative;margin:0;cursor:pointer;box-sizing:border-box;width:", ";height:", ";background-color:", ";border-radius:", ";border-style:solid;border-width:", ";border-color:", ";margin-block:", ";", ""], ({
  theme
}) => theme.radioButton.width, ({
  theme
}) => theme.radioButton.height, ({
  theme
}) => theme.selectableWidget.backgroundColor.default, ({
  theme
}) => theme.border.radius.round, ({
  theme
}) => theme.border.width.default, ({
  theme
}) => theme.border.color.medium.default, ({
  theme
}) => theme.spacing.xxxxsmall.default, isMobile(css(["margin-block:", ";"], ({
  theme
}) => theme.spacing.xxxxsmall.mobile)));
const MobileFullScreenCheckbox = /*#__PURE__*/styled(Checkbox).withConfig({
  componentId: "sc-storm-ui-40025937__sc-1a042f9-5"
})(["margin-block:", ";", ""], ({
  theme
}) => theme.spacing.xxxxsmall.default, isMobile(css(["margin-block:", ";"], ({
  theme
}) => theme.spacing.xxxxsmall.mobile)));
const MobileFullScreenRenderWrapper = /*#__PURE__*/styled('span').withConfig({
  componentId: "sc-storm-ui-40025937__sc-1a042f9-6"
})(["width:100%;display:flex;flex-direction:column;background:", ";overflow:hidden;border-inline:", ";border-block-start:", ";:first-of-type{border-start-start-radius:", ";border-start-end-radius:", ";}:last-of-type{border-end-start-radius:", ";border-end-end-radius:", ";border-block-end:", ";}"], ({
  theme
}) => theme.selectableWidget.backgroundColor.default, ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.subtle.default);
const MobileFullScreenButton = /*#__PURE__*/styled('button').withConfig({
  componentId: "sc-storm-ui-40025937__sc-1a042f9-7"
})(["cursor:pointer;width:100%;display:flex;flex-direction:row;background:", ";overflow:hidden;padding:", ";border:none;border-radius:", ";gap:", ";outline:none;", " :hover{", "{background-color:", ";border-color:", ";}", "{", "}}:active{", "{background-color:", ";border-color:", ";}}:disabled{cursor:not-allowed;", "{cursor:not-allowed;background-color:", ";border-color:", ";", "}}:focus-visible{", "{outline:none;", "}", "{outline:none;", "}}"], ({
  theme
}) => theme.selectableWidget.backgroundColor.default, ({
  theme
}) => theme.spacing.small.mobile, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.selectableWidget.controlLabelGap.mobile, ({
  selected
}) => selected && css(["", "{background-color:", ";border-color:transparent;}", "::after{content:'';position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:", ";height:", ";background-color:", ";border-radius:50%;}"], MobileFullScreenRadio, ({
  theme
}) => theme.selectableWidget.backgroundColor.selected, MobileFullScreenRadio, ({
  theme
}) => theme.radioButton.dot.width, ({
  theme
}) => theme.radioButton.dot.height, ({
  theme
}) => theme.color.gray[0]), MobileFullScreenRadio, ({
  theme
}) => theme.selectableWidget.backgroundColor.hover, ({
  theme
}) => theme.border.color.medium.hover, MobileFullScreenCheckbox, ({
  disabled
}) => !disabled && hoverMixin, MobileFullScreenRadio, ({
  theme
}) => theme.selectableWidget.backgroundColor.active, ({
  theme
}) => theme.border.color.medium.active, MobileFullScreenRadio, ({
  theme
}) => theme.selectableWidget.backgroundColor.unavailableInverted, ({
  theme
}) => theme.border.color.medium.unavailable, ({
  selected
}) => selected && css(["background-color:", ";"], ({
  theme
}) => theme.selectableWidget.backgroundColor.unavailableSelected), MobileFullScreenRadio, focusOutline, MobileFullScreenCheckbox, focusOutline);

export { Checkbox as C, MobileFullScreenRenderWrapper as M, RenderWrapper as R, SelectButtonContent as S, MobileFullScreenButton as a, MobileFullScreenCheckbox as b, MobileFullScreenRadio as c, SelectButton as d };
//# sourceMappingURL=SelectOption.styles-jmsWRFc7.js.map
